import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import notifierReducer from './notifierReducer';
import usersReducer from '../views/Management/reducers/UsersReducer';
import operatorsReducer from '../views/Management/reducers/OperatorsReducer';
import settingsReducer from '../views/Management/reducers/SettingsReducer';
import dashboardInspectReducer from '../views/Dashboard/reducers/DashboardInspectReducer';
import mapReducer from '../components/Map/reducers/MapReducer';
import dualMapReducer from '../views/DualMap/reducers/DualMapReducer';
import voiceReducer from '../views/FailuresTracker/reducers/VoiceReducer';
import packetReducer from '../views/FailuresTracker/reducers/PacketReducer';
import failuresReducer from '../views/FailuresTracker/reducers/FailuresReducer';
import siteOptReducer from '../views/SiteOptimizationsTracker/reducers/SiteOptReducer';
import repositoryPdfReducer from '../views/RepositoryPdf/reducers/RepositoryPdfReducer';
import repositoryExcelReducer from '../views/RepositoryExcel/reducers/RepositoryExcelReducer';
import driveTestUploadReducer from '../views/DriveTestUpload/reducers/DriveTestUploadReducer';

const rootReducer = combineReducers({
	session: sessionReducer,
	usersReducer,
	notifierReducer,
	operatorsReducer,
	settingsReducer,
	dashboardInspectReducer,
	mapReducer,
	dualMapReducer,
	voiceReducer,
	packetReducer,
	failuresReducer,
	siteOptReducer,
	repositoryPdfReducer,
	repositoryExcelReducer,
	driveTestUploadReducer
});

export default rootReducer;
